export function getLanguageFromURL(path: string) {
    return path.split("/")[1];
}

export function replaceLanguageInURL(url: URL, language: string) {
    url.pathname = url.pathname.replace(new RegExp('^/([a-z]){2}/','g'), `/${language}/`);
    return url;
}
